import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row no-wrap" }
const _hoisted_2 = { class: "row justify-between" }
const _hoisted_3 = { class: "column text-caption text-right sfx-table__td-indicator-values" }
const _hoisted_4 = { class: "text-navy-base ellipsis" }
const _hoisted_5 = { class: "text-navy-base ellipsis sfx-table__td-indicator-values-total" }
const _hoisted_6 = { class: "text-info ellipsis" }
const _hoisted_7 = { class: "q-px-md items-center line-clamp ellipsis" }

import { computed } from "vue"

//region Props and Emits

const INDICATOR_SIZE = "44px"
const INDICATOR_THICKNESS = 0.37

//endregion

export default /*#__PURE__*/_defineComponent({
  __name: 'SfxTableTdIndicator',
  props: {
  text: [String, Number],

  current: {
    type: Number,
    default: 0,
  },

  total: {
    type: Number,
    default: 0,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const textClass = computed(() => (props.text ? "text-h6" : "text-no-value"))

const circularProgressColor = computed(() => (props.total >= props.current ? "info" : "negative"))

const circularProgressClass = computed(() => {
  return { "text-negative": props.current > props.total }
})

const percentage = computed<number>(() =>
  props.total === 0 ? 0 : Math.round((props.current / props.total) * 100)
)


return (_ctx: any,_cache: any) => {
  const _component_q_circular_progress = _resolveComponent("q-circular-progress")!
  const _component_q_td = _resolveComponent("q-td")!

  return (_openBlock(), _createBlock(_component_q_td, {
    class: _normalizeClass(["sfx-table__td sfx-table__td-indicator text-center", textClass.value])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_q_circular_progress, _mergeProps({
            reverse: "",
            class: circularProgressClass.value,
            color: circularProgressColor.value,
            "track-color": "line-and-filler",
            size: INDICATOR_SIZE,
            thickness: INDICATOR_THICKNESS,
            value: percentage.value
          }, _ctx.$attrs), null, 16, ["class", "color", "value"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(props.current), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(props.total), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(percentage.value) + "%", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(props.text || _ctx.$t("sfxTable.empty_no_value")), 1)
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})